import MUIDataTable from 'mui-datatables'
import PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { Container } from 'src/modules/ui'
import { formatDateSearch, formatPrice } from 'src/utils'

const DraftOrderList = ({ draftOrders }) => {
  const history = useHistory()

  const data = draftOrders.map(({ createdAt, total, user, ...draft }) => ({
    ...draft,
    createdAt: formatDateSearch(createdAt),
    total: formatPrice(total),
    user: `${user.firstName} ${user.lastName}`,
  }))

  const columns = [
    {
      name: 'id',
      label: 'Draft Number',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'total',
      label: 'Amount (£)',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'createdAt',
      label: 'Date Drafted',
      options: {
        filter: false,
        sort: true,
        sortDirection: 'asc',
      },
    },
    {
      name: 'user',
      label: 'Drafted By',
      options: {
        filter: true,
        sort: true,
      },
    },
  ]

  const options = {
    download: false,
    elevation: 0,
    onRowClick: row => {
      history.push(`/purchasing/drafts/${row[0]}`)
    },
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: 'none',
    viewColumns: false,
  }

  return (
    <Container muiTable>
      <MUIDataTable
        columns={columns}
        data={data}
        options={options}
        title="Draft Orders"
      />
    </Container>
  )
}

DraftOrderList.propTypes = {
  draftOrders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      createdAt: PropTypes.string,
      total: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    })
  ),
}

export default DraftOrderList
